var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAirplaneLeft = function SvgAirplaneLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 21,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M1.27 2.27c.71-.71 1.86-.7 2.55.03l3.79 3.95 9.25-3.06 1.94 1.94-7.71 4.75 3.9 4.06 2.5-.41 1.75 1.75-3.68 1.29-1.29 3.68-1.75-1.75.41-2.5-4.06-3.9-4.75 7.71-1.94-1.94 3.06-9.25-3.95-3.79c-.71-.7-.72-1.85-.02-2.56"
  })));
};
export default SvgAirplaneLeft;